import { ChosenLeaseCar, Color, LeaseCarDataService, Option, Store, Upgrade } from 'types';
import { checkIfPaymentInAdvanceAmountIsValid } from 'utils';

export const chosenLeaseCarSelector = (state: Store): ChosenLeaseCar => state.chosenLeaseCar;

export const chosenOptionsSelector = (state: Store): Option[] => state.chosenLeaseCar.options;

export const chosenServicesSelector = (state: Store): LeaseCarDataService[] =>
	state.chosenLeaseCar.services;

export const chosenUpgradeSelector = (state: Store): Upgrade | undefined =>
	state.chosenLeaseCar.upgrade || undefined;

export const chosenColorSelector = (state: Store): Color | undefined =>
	state.chosenLeaseCar.color || undefined;

export const chosenOrderCodeSelector = (state: Store): string | undefined =>
	state.chosenLeaseCar.color?.orderCode || undefined;

export const chosenDurationSelector = (state: Store): string => state.chosenLeaseCar.duration;

export const chosenDurationPriceSelector = ({ leaseCarData, chosenLeaseCar }: Store): number => {
	const { duration } = chosenLeaseCar;
	const pricePoint = leaseCarData?.privateLeaseData.groupedPricePoints[Number(duration)];

	return pricePoint?.price || 0;
};

export const chosenKilometrageSelector = (state: Store): string => state.chosenLeaseCar.kilometrage;

export const chosenPricePointIdSelector = (state: Store): number =>
	state.chosenLeaseCar.pricePointId;

export const chosenPricePointPriceSelector = (state: Store): number =>
	state.chosenLeaseCar.pricePointPrice;

export const checkoutBeginsSelector = (state: Store): boolean =>
	state.chosenLeaseCar.checkoutBegins;

export const paymentInAdvanceAmountSelector = (state: Store): number | undefined =>
	state.chosenLeaseCar.paymentInAdvanceAmount;

export const paymentInAdvanceChoiceSelector = (state: Store): boolean =>
	state.chosenLeaseCar.paymentInAdvanceChoice;

export const paymentInAdvanceValidSelector = ({
	chosenLeaseCar: { duration, paymentInAdvanceAmount, totalPrice },
}: Store): boolean =>
	checkIfPaymentInAdvanceAmountIsValid(paymentInAdvanceAmount, totalPrice, Number(duration));

export const totalPricePerMonthSelector = (state: Store): number => state.chosenLeaseCar.totalPrice;

export const totalContractPriceSelector = (state: Store): number =>
	state.chosenLeaseCar.totalPrice * Number(state.chosenLeaseCar.duration);
